<div class="row justify-content-center align-items-center" mat-dialog-title>
    <div class="col-md-10 col-10">
        <h5 class="text-left txt-primario">Reglas de ajuste - {{this.siniestro}}</h5>
    </div>
    <div class="col-md-2 col-2 text-right">
        <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
    </div>
</div>

<mat-dialog-content class="py-0">
    <div class="row mb-2">
        <div class="col-md-12 my-4 overflow-auto">
            <table mat-table multiTemplateDataRows [dataSource]="verififcaReglasSiniestro"
                class="table d-xl-table d-md-table table-responsive my-2">
                <ng-container matColumnDef="Clave">
                    <th mat-header-cell class="px-2" *matHeaderCellDef>Clave</th>
                    <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.regla}}</td>
                </ng-container>
                <ng-container matColumnDef="Regla">
                    <th mat-header-cell class="px-2" *matHeaderCellDef>Regla</th>
                    <td mat-cell *matCellDef="let element" class="mx-1">{{element?.descripcion}}</td>
                </ng-container>
                <ng-container matColumnDef="Seleccion">
                    <th mat-header-cell class="px-2" *matHeaderCellDef>Selección</th>
                    <td mat-cell *matCellDef="let element" class="mx-1">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleRow(element)"
                            [checked]="selection.isSelected(element) || element?.seleccionar == 1"
                            [ngModel]="element.seleccionar"
                            (ngModelChange)="element.seleccionar = $event ? 1 : 0">
                        </mat-checkbox>
                    </td>
                </ng-container>


                <!-- Sin resultados -->
                <ng-container matColumnDef="noData">
                    <td mat-footer-cell *matFooterCellDef colspan="3">
                        <small>No se encontró ningún resultado</small>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;"> </tr>
                <tr mat-footer-row *matFooterRowDef="['noData']"
                    [ngClass]="(verififcaReglasSiniestro?.data?.length === 0) ? '':'ocultarPaginator'">
                </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20, 50,100]" showFirstLastButtons
                aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="row mx-0 justify-content-md-end">
    <div class="col-md-auto col-auto">
        <button type="submit" color="primary" class="mx-1 my-1" mat-raised-button (click)="guardarSeleccion()">
            Guardar
        </button>
    </div>
    <div class="col-md-auto col-auto">
        <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Cancelar')">
            Cancelar
        </button>
    </div>
</mat-dialog-actions>